import React, { Component } from "react";
import PropTypes from 'prop-types';

class Timeline extends Component {
  static defaultProps = {
    data: {
      status: "initialized",
      nodes: [
        {
          title: "Initialized",
          dataIndex: "initialized"
        },
        {
          title: "Acknowledged",
          dataIndex: "acknowledged"
        },
        {
          title: "Processed",
          dataIndex: "processed"
        }
      ]
    },
    mode: "vertical" || "horizontal"
  };
  render() {
    const { data, mode } = this.props;
    const lastNode = data.nodes.find(x => x.dataIndex === data.status);
    const lastNodeIndex = lastNode && data.nodes.indexOf(lastNode);
    return (
      <React.Fragment>
        <div className={`timeline-container ${mode}`}>
          {data &&
            data.nodes.map((node, i) => (
              <div className={`timeline-wrapper ${mode}`}>
                {i !== 0 && (
                  <div
                    className={`timeline-line ${
                      i <= lastNodeIndex
                        ? `line-solid ${mode}`
                        : `line-dotted ${mode}`
                    }`}
                  />
                )}
                <div className="node-container">
                  <div className={`title ${mode}`}>{node.title}</div>
                  <div className="timeline-node">
                    {i <= lastNodeIndex && (
                      <div
                        className={
                          i === lastNodeIndex ? "timeline-circle timeline-animate" : "timeline-circle"
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </React.Fragment>
    );
  }

}

export default Timeline;
